import { memo } from 'react';
import { Stack, Typography } from '@mui/material';

const InfoField = memo(() => {
	return (
		<Stack
			spacing="4px"
			sx={{
				pt: '4px',
			}}
		>
			<Typography
				sx={{
					color: '#00000099',
					fontSize: '10px',
					fontWeight: '400',
					fontFamily: 'Roboto',
				}}
			>
				PVP
			</Typography>

			<Typography
				sx={{
					color: '#00000099',
					fontSize: '10px',
					fontWeight: '400',
					fontFamily: 'Roboto',
				}}
			>
				TSU
			</Typography>

			<Typography
				sx={{
					color: '#00000099',
					fontSize: '10px',
					fontWeight: '400',
					fontFamily: 'Roboto',
				}}
			>
				MG
			</Typography>
		</Stack>
	);
});

export default InfoField;
